'use client';

import {
    PublicCourse,
    PublicEducator,
    PublicOccurrence,
} from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { OccurrenceSection } from '../../../../../../../components/OccurrenceSection';
import { useOccurrencesWithoutExpiredOffers } from '../../../../../../../hooks/useOccurrencesWithoutExpiredOffers';
import { PoweredBy } from '../../../../../../../components/PoweredBy';
import styles from './styles.module.scss';
import { CalendarLightIcon } from '../../../../../../../components/Icons';

export type OccurrencesWithEmptyPlaceholderProps = {
    course: PublicCourse;
    educator: PublicEducator;
    occurrences: PublicOccurrence[];
};

const OccurrencesWithEmptyPlaceholder: FunctionComponent<OccurrencesWithEmptyPlaceholderProps> = ({
    course,
    educator,
    occurrences,
}) => {
    if (occurrences.length === 0) {
        return (
            <div className={styles.emptyState}>
                <div className={styles.emptyStateIcon}>
                    <CalendarLightIcon />
                </div>
                <h3>No dates available</h3>
            </div>
        );
    }

    return (
        <OccurrenceSection
            course={course}
            educator={educator}
            occurrences={occurrences}
            showTitle={false}
        />
    );
};

export type DatesProps = {
    course: PublicCourse;
    educator: PublicEducator;
    occurrences: PublicOccurrence[];
};

export const Dates: FunctionComponent<DatesProps> = ({ course, educator, occurrences }) => {
    const occurrencesWithoutExpiredOffers = useOccurrencesWithoutExpiredOffers({
        occurrences: occurrences,
    });

    return (
        <div className={styles.container}>
            <OccurrencesWithEmptyPlaceholder
                course={course}
                educator={educator}
                occurrences={occurrencesWithoutExpiredOffers}
            />
            <footer>
                <PoweredBy origin="embed" />
            </footer>
        </div>
    );
};
